import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976D2',
    },
    secondary: {
      main: '#4CAF50',
    },
  },
  typography: {
    fontFamily: 'Monaco, monospace',
  },
});

export default theme;

